module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-02@2x.8748fb49.jpg";